import { styled } from 'styled-components'
import { Paragraph } from 'suomifi-ui-components'
import { FormContainer as FormContainerBase } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'

export const FormContainer = styled(FormContainerBase)`
  .fi-single-select {
    margin-bottom: ${({ theme }) => theme.spacing.l};
  }

  .fi-radio-button-group {
    margin-top: ${({ theme }) => theme.spacing.l};
  }
`

export const SmallTextParagraph = styled(Paragraph)`
  ${({ theme }) => theme.typography.bodyTextSmall};
`
